import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { GradeService } from '../../_services/grades.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarService } from 'src/app/_services/snackBar.service';


declare var $: any;


@Component({
  selector: 'app-class-reorder-modal',
  templateUrl: './class-reorder-modal.component.html',
  styleUrls: ['./class-reorder-modal.component.scss']
})
export class ClassReorderModalComponent {
  currLang;
  classSubscribtion$:Subscription;
  showSortIcon:boolean = true;
  dataArray = [];
  loading = false;
  
  constructor(
    private translate: TranslateService,
    private globalService: GlobalService,
    private gradesService: GradeService,
    private dataService: DataService,
    private _snackBar: MatSnackBar,
    private snackBar: SnackbarService,

  ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    $(document).on('hidden.bs.modal', '#classReorderModal', () => {
      this.closeModalHandler();
    })

    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    let s = this.gradesService.getClassesForReorder().subscribe((res: any) => {
      if(res && res?.length > 0){
        this.dataArray = res;
      }
      console.log('classes4Reorder',res);
      
    })
    this.classSubscribtion$?.add(s);
  }

  dropClass(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );

    // console.log(event.container.data);
  }

  saveClassesSort(){
    this.loading = true;
    let body = this.dataArray.map((clazz, index) => ({
      class_id: clazz.id,
      position:index,
    }));
    
    this.gradesService.updateClassSorting(body).subscribe(res=>{
    },err=>{
      // error in updating the grades 
            this.loading = false; 
            this.snackBar.setSnackBarMessage(err.message);
            this._snackBar.openFromComponent(SnackBarErrorComponent, {
              duration: 4000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
    },()=>{
      this.dataService.updateGradesCache$().subscribe(res=>{
      },err=>{
        // error in updating grades cache  
            this.loading = false; 
            this.snackBar.setSnackBarMessage(err.message);
            this._snackBar.openFromComponent(SnackBarErrorComponent, {
              duration: 4000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
      },()=>{
        this.loading = false;
        this.closeModalHandler();
      })
    })
  }



  closeModalHandler() {
    this.classSubscribtion$?.unsubscribe();
    $("#classReorderModal").modal("hide");
  }
  
}
